/**
 * The ONE Highcharts entry point for the whole app.
 *
 * Every chart component must import Highcharts from this file, never from
 * 'highcharts' or 'highcharts/highstock' directly. Highcharts 12 modules
 * attach to the shared namespace by side-effect import (they read the core
 * from the global the core sets on load); importing the core elsewhere
 * before these modules ran gives runtime error #17 ("series type does not
 * exist") for windbarb / polar charts.
 *
 * Stock build: the timeline charts use rangeSelector + navigator.
 */
import Highcharts from 'highcharts/highstock';
import 'highcharts/highcharts-more';        // polar axes (wind rose)
import 'highcharts/modules/windbarb';       // wind direction barbs
import 'highcharts/modules/accessibility';  // keyboard nav + aria

export const STATION_TZ = 'Europe/Belgrade';

// EU 24 h labels everywhere (Stock's navigator defaults to %I %p AM/PM).
const dateTimeLabelFormats24h = {
    millisecond: '%H:%M:%S.%L',
    second: '%H:%M:%S',
    minute: '%H:%M',
    hour: '%H:%M',
    day: '%e %b',
    week: '%e %b',
    month: "%b '%y",
    year: '%Y',
};

Highcharts.setOptions({
    credits: { enabled: false },
    time: { timezone: STATION_TZ },
    chart: { style: { fontFeatureSettings: '"tnum"' } },
    xAxis: { dateTimeLabelFormats: dateTimeLabelFormats24h },
    navigator: { xAxis: { dateTimeLabelFormats: dateTimeLabelFormats24h } },
});

export default Highcharts;
